import React from "react";
import * as Icons from "Components/Icons";

import classes from "./styles.module.scss";

interface closeButtonProps {
   toggle(): void;
}

const closeButton: React.FC<closeButtonProps> = ({ toggle }) => {
   return <div className={classes.closeButton} tabIndex={0} role="button" aria-label="close" onClick={() => toggle()}>
      <Icons.Close className="icon" />
   </div>
}

export default closeButton;